module.exports = __webpack_public_path__ + "static/icons/icon-resort-manager-c1411a09b7cb9ede558b2ec25ed2e259.svg";